<template>
  <div v-if="label" class="mb-2 text-sm text-gray-900">{{ label }}</div>
  <div
    class="max-h-60 overflow-auto bg-white text-sm shadow-none focus:outline-none"
    :class="['w-full md:w-auto']"
  >
    <div
      v-for="(item, key) in items"
      :key="key"
      class="relative cursor-pointer select-none py-2 pl-16 pr-3 hover:bg-gray-100"
      :class="[modelValue && modelValue.id === item.id ? 'bg-gray-100' : '']"
      @click="emit('update:modelValue', item)"
    >
      <div class="flex items-center">
        <ImageComponent
          v-if="item.image"
          alt="image for the select item"
          :asset-info="{ name: item.image, type: 'flag', extension: 'svg' }"
          class="h-5 w-5 flex-shrink-0 rounded-full"
        />
        <span
          :class="[
            modelValue && modelValue.name === item.name ? 'font-semibold' : 'font-normal',
            'ml-3 truncate'
          ]"
        >
          {{ item.name }}
        </span>
        <font-awesome-icon
          v-if="modelValue && modelValue.name === item.name"
          size="lg"
          class="ml-2 flex-shrink-0 text-gray-900"
          aria-hidden="true"
          :icon="['fal', 'check']"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ISelect } from '@/interfaces/components/ISelectComponent'

const { items, modelValue, label = '' } = defineProps<ISelect>()

const emit = defineEmits(['update:modelValue'])
</script>
